export default __webpack_public_path__ + "static/media/bbdm.9f0cc5f3.png";